import dynamic from 'next/dynamic';
import {
  DESTEK_EMAIL_PARTS,
  INFO_EMAIL_PARTS,
  YARDIM_EMAIL_PARTS,
  KEP_EMAIL_PARTS,
} from '@/shared/config/siteContact';

/**
 * Bot-resistant email link — SSoT.
 *
 * Pattern: dynamic({ ssr: false }) → SSR HTML'de email görünmez. Bot
 * sayfayı crawl ederse statik kaynak içinde mailto/email yok.
 * Browser hydrate sonrası `_ObfuscatedEmailInner` çalışır, parça birleşir.
 *
 * Kullanım:
 *   <DestekEmail className="hover:underline" />
 *   <InfoEmail />
 *   <KepEmail />
 *
 * Yeni e-posta tipi: siteContact.ts'e `*_EMAIL_PARTS` tuple ekle + burada export et.
 */

const Inner = dynamic(
  () => import('./_ObfuscatedEmailInner').then((m) => m.ObfuscatedEmailInner),
  { ssr: false, loading: () => null },
);

interface Props {
  className?: string;
}

export function DestekEmail({ className }: Props) {
  return <Inner parts={DESTEK_EMAIL_PARTS} className={className} />;
}

export function InfoEmail({ className }: Props) {
  return <Inner parts={INFO_EMAIL_PARTS} className={className} />;
}

export function YardimEmail({ className }: Props) {
  return <Inner parts={YARDIM_EMAIL_PARTS} className={className} />;
}

export function KepEmail({ className }: Props) {
  return <Inner parts={KEP_EMAIL_PARTS} className={className} />;
}
